import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { PageLoading } from "@/components/shared/PageLoading";

// Lazy loaded pages
const BookingFlow = lazy(() => import("@/pages/BookingFlow"));

const BookingRoutes = () => {
  return (
    <Routes>
      <Route path="/:therapistId" element={
        <Suspense fallback={<PageLoading />}>
          <BookingFlow />
        </Suspense>
      } />
    </Routes>
  );
};

export default BookingRoutes;